import PoliticaPrivacidad from "../../components/docs/PoliticaPrivacidad"


function PolitiPrivacidad() {
    return (
    <PoliticaPrivacidad />
     
    )
  }
  
  export default PolitiPrivacidad
  